import {
  ContestViewContest,
  ContestViewEntry,
  User,
} from '@freelancer/datastore';

export enum PreviewModalResponse {
  AWARD,
  START_CHAT,
}

export interface PreviewModalDetails {
  readonly contest: ContestViewContest;
  readonly entry: ContestViewEntry;
  readonly freelancer: User;
  readonly userId: number;
  readonly isContestOwner: boolean;
  readonly hasContestAwardedEntry: boolean;
}
